import { Box, Button, Card, Chip, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { FC, UIEvent, useEffect, useRef, useState } from "react";

import MaterialReactTable from "material-react-table";
import { API_SLUGS, ROUTES } from "../../constants";
import { useTableInfinity } from "../../hooks/process/useTableInfinity";
import { BorderColorOutlined, Close, ContentCopy } from "@mui/icons-material";
import copy from "copy-to-clipboard";
import { IAlertState, useAlertState } from "../../store/alertState";
import ModalWrapper from "../common/modal/wrapper";
import { Plus } from "../../icons/plus";
import AddPolicyForm from "./addPolicies"
import { useHistory } from "react-router-dom";
var format = require("string-template");


const limit = 30;
const disableInfiniteScroll = false;

const PoliciesTable: FC<any> = () => {
    const path = API_SLUGS.TOOL_POLICIES + `?limit={limit}&offset={offset}`;
    const tableContainerRef = useRef<HTMLDivElement>(null);
    const { setMessage } = useAlertState() as IAlertState;

    const { rows, fetchMoreOnBottomReached, isFetching, resetAndFetch } = useTableInfinity(
        "policies",
        path,
        tableContainerRef,
        limit
    );

    useEffect(() => {
        if (!disableInfiniteScroll) {
            fetchMoreOnBottomReached(tableContainerRef.current);
        }
    }, [fetchMoreOnBottomReached])

    const navigate = useHistory();

    return (
        <Card elevation={0} sx={{ textAlign: "left", overflow: "auto", height: "100%" }}>
                
                    <MaterialReactTable
                        muiTablePaperProps={{
                            elevation: 0
                        }}

                        enableGlobalFilter={false}
                        columns={[
                            {
                                accessorKey: "name",
                                header: "Policy Name",
                            },
                            // TODO: Figure out a better term to let the user know that some action is required, [Pending is confusing]
                            // {
                            //     accessorKey: "isPending",
                            //     header: "",
                            //     Cell: (params: any) => {

                            //         if (params?.row?.original?.isPending) {
                            //             return (<Chip
                            //                 label="Pending"
                            //                 size="small"
                            //                 sx={{
                            //                     minWidth: "4em",
                            //                     justifyContent: "center",
                            //                 }}
                            //                 variant={"outlined"}
                            //                 color="error"
                            //             />)
                            //         } else { return (<></>) }
                            //     },
                            //     size: 50
                            // },
                            {
                                accessorKey: "id",
                                header: "ID",
                                Cell: (params: any) => (
                                    <pre
                                        style={{ display: "inline", cursor: "pointer" }}
                                        onClick={() => {
                                            copy(
                                                params?.row?.original?.id
                                            );

                                            setMessage({
                                                title: "Policy ID copied to the clipboard",
                                                type: "success",
                                            });
                                        }}
                                    >
                                        <ContentCopy fontSize="inherit" />
                                        {params?.row?.original?.id.split("-")[0]}
                                    </pre>
                                ),

                            },
                            {
                                //@ts-ignore
                                accessorKey: "action",
                                header: "Actions",
                                Cell: (params: any) => {
                                    const policyPath = ROUTES.POLICY.replace(":policyId", params?.row?.original?.id)
                                    return (
                                        <Box sx={{ display: "flex", justifyContent: "start" }}>
                                            <Tooltip title="Edit">
                                                <Button variant='outlined' onClick={() => navigate.push(policyPath)} name={params?.row?.original?.name} size='small' sx={{color: 'text.primary', borderColor: 'neutral.300', mr:1, minWidth: '45px', ml: 0.5}}> 
                                                

                                                    <BorderColorOutlined />
                                                </Button>
                                            </Tooltip>

                                        </Box>)
                                },

                            },

                        ]}
                        data={rows}
                        initialState={{
                            density: "compact"
                        }}
                        enableColumnActions={false}
                        enableSorting={false}
                        enableStickyHeader


                        enableTopToolbar={false}

                        enablePagination={false}
                        enableDensityToggle={false}
                        enableColumnFilters={false}
                        // enableRowVirtualization
                        state={{
                            showProgressBars: isFetching,
                        }}
                        muiTableContainerProps={{
                            ref: tableContainerRef, //get access to the table container element
                            sx: { maxHeight: "calc(100vh - 350px)" }, //give the table a max height
                            onScroll: (
                                event: UIEvent<HTMLDivElement> //add an event listener to the table container element
                            ) => {
                                if (!disableInfiniteScroll) {
                                    fetchMoreOnBottomReached(event.target as HTMLDivElement)
                                }

                            }
                        }}
                    />


                </Card>

    );
};

export default PoliciesTable;